import { createAdvancedOrderProduct } from "./global";

function moveProductElements(product) {
    const availability = product.find('.ratings-wrapper .availability');
    const prices = product.find('.prices');
    const pTools = product.find('.p-tools');
    const image = product.find('.image');

    availability.insertAfter(prices);
    pTools.insertAfter(availability);
    pTools.appendTo(image);

    const discountRaw = prices.find('.price-save').text().trim();
    const discount = discountRaw.replace(/[()]/g, '').trim();
    const flagAction = product.find('.flag-action');

    if (discount && flagAction.length) {
        flagAction.text(discount);
    }
}

function replaceTemplateImage() {
    const template = '/user/documents/able-images/template.jpg';
    const root = $('.product .image');
    root.find('img[src*="/missing_images/"]').attr('src', template);
    root.find('img[data-micro-image*="/missing_images/"]').attr('data-micro-image', template);
    root.filter('[href*="/missing_images/"]').attr('href', template);
}

function addImageAndPriceToAdvancedOrder() {
    $(document).on('click', '.product .btn.add-to-cart-button', function () {
        const product = $(this).closest('.product')
        const image = product.find('.image img').attr('src')
        const price = product.find('.price.price-final').text()
        const url = product.find('.name').attr('href')

        createAdvancedOrderProduct({ image, price, url })
    })
}

export const transformProducts = () => {
    const products = $('.products:not(#productsTop) .product')

    if (products.length) {
        products.each(function () {
            const product = $(this)

            // Přepozicování elementů
            moveProductElements(product)

            // Logo misto default missing image template
            replaceTemplateImage()
        })

        // Přidání obrázku a ceny do mezikošíku
        addImageAndPriceToAdvancedOrder()
    }
}

export function initProducts() {
    transformProducts()

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        transformProducts()
    })
}
